import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import MainPage from '../components/MainPage';
import getDeviceAuthSettings from '../actions/api/deviceAuth/getDeviceAuthSettings';
import getDeviceAuthSubscriptionSettings from '../actions/api/deviceAuth/getDeviceAuthSubscriptionSettings';
import getOperators from '../actions/api/operators/getOperators';
import { ROLE } from '../lib/constants';
import config from '../config';
import { SUCCESS_API_GET_ACCESS_CONTROL_OPERATORS } from '../actions/actionTypes';

/**
 * アクセス制御設定画面のコンテナコンポーネント
 * @returns {JSX.Element} アクセス制御設定画面のコンテナコンポーネント
 */
const AccessControlContainer = () => {
  const dispatch = useDispatch();
  const apiToken = useSelector(state => state.main.apiToken);
  const targetGroupId = useSelector(state => state.main.targetGroupId);
  const isLogin = useSelector(state => state.main.isLogin);
  const groups = useSelector(state => state.group.groups);

  // UIの初期状態を設定
  useEffect(() => {
    dispatch({ type: 'CLOSE_MENU' });
    dispatch({ type: 'OPEN_ACCESS_CONTROL' });
  }, [apiToken, dispatch, targetGroupId]);

  // デバイス認証設定情報を取得
  useEffect(() => {
    dispatch(getDeviceAuthSettings(apiToken));
  }, [apiToken, dispatch]);

  // デバイス認証の通知先設定情報を取得
  useEffect(() => {
    dispatch(getDeviceAuthSubscriptionSettings(apiToken, targetGroupId));
  }, [apiToken, dispatch, targetGroupId]);

  // メール送信先ユーザーの選択肢を取得
  useEffect(() => {
    if (groups != null && groups.length === 0) {
      return;
    }

    const defaultGroupId =
      groups.find(group => group.isDefault)?.id || groups[0].id;
    dispatch(
      getOperators(
        apiToken,
        {
          accountStatuses: config.searchAccountStatus.enable,
          roles: [ROLE.ADMIN, ROLE.COMPANY_ADMIN],
          groupIds: [defaultGroupId],
        },
        SUCCESS_API_GET_ACCESS_CONTROL_OPERATORS,
      ),
    );
  }, [apiToken, dispatch, groups]);

  if (!isLogin) {
    return <Redirect to="/login" />;
  }

  return <MainPage />;
};

export default AccessControlContainer;
